import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import withStyles from 'beam/dist/styles'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from 'beam/dist/Dialog'
import Button from 'beam/dist/Button'
import Badge from 'beam/dist/Badge'
import BeamIcon from 'beam/dist/BeamIcon'
import Typography from 'beam/dist/Typography'

const styles = theme => ({
  root: {},
  statusRoot: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  badge: {
    margin: theme.spacing(0, 1),
  },
  mediaType: {
    padding: theme.spacing(0, 1),
    color: theme.palette.text.secondary,
  },
  available: {
    width: 20,
    color: theme.palette.common.white,
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.color.green[500],
  },
  error: {
    width: 20,
    color: theme.palette.common.white,
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.error.main,
  },
})

const RestoreMediaDialog = ({ open, delayedStorageStatus, onClose, onRestore, classes, t }) => {
  const handleClose = () => onClose()

  const handleRestore = () => {
    onRestore()
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('restoreMediaFiles')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('restoreMediaFileDesc')}</DialogContentText>
        <div className={classes.statusRoot}>
          {Object.keys(delayedStorageStatus).map(mediaType => (
            <Badge
              key={mediaType}
              color="default"
              badgeContent={<BeamIcon size="18">{delayedStorageStatus[mediaType] === false ? 'Check' : 'Cancel'}</BeamIcon>}
              classes={{ badge: delayedStorageStatus[mediaType] === false ? classes.available : classes.error }}
              className={classes.badge}
            >
              <Typography variant="subtitle1" className={classes.mediaType}>
                {t(mediaType)}
              </Typography>
            </Badge>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          {t('continueLabel')}
        </Button>
        <Button color="secondary" onClick={handleRestore}>
          {t('restore')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

RestoreMediaDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  delayedStorageStatus: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onRestore: PropTypes.func,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

RestoreMediaDialog.defaultProps = {
  onClose: () => {},
  onRestore: () => {},
}

export default withTranslation()(withStyles(styles)(RestoreMediaDialog))
